<template>
    <b-card :class="{ [`root-node`]: isRoot }" @click="toggleFold">
        <div class="node-infor-wrapper d-flex">
            <div class="node-spinner d-none">
                <b-spinner variant="secondary" />
            </div>
            <div class="group-icons">
                <div v-if="isRoot || hasChildren">
                    <feather-icon size="26" icon="MoreHorizontalIcon" />
                    <feather-icon size="26" style="position: relative; top: -8px; left: -26px"
                        icon="MoreHorizontalIcon" />
                </div>
                <div v-else>
                    <feather-icon size="26" icon="MoreVerticalIcon" />
                    <feather-icon size="26" style="position: relative; left: -18px;" icon="MoreVerticalIcon" />
                </div>
            </div>
            <div>
                <b-card-title>
                    {{ item.title }}
                </b-card-title>
                <b-card-sub-title v-if="!isRoot && !hasChildren">
                    <pre class="card-subtitle text-muted">{{ item.description }}</pre>
                </b-card-sub-title>
            </div>
        </div>
        <div class="action-wrapper d-flex">
            <b-button-group :vertical="!isRoot && !hasChildren">
                <b-button variant="outline-primary" size="sm" v-if="isRoot || hasChildren" @click="handleCreate">
                    {{ $t("button.addreply") }}
                </b-button>
                <b-button variant="outline-primary" size="sm" @click="handleUpdate">
                    {{ $t("button.edit") }}
                </b-button>
                <b-button variant="outline-primary" size="sm" @click="handleDelete">
                    {{ $t("button.delete") }}
                </b-button>
            </b-button-group>
            <feather-icon v-if="isRoot && hasChildren" class="ChevronRightIcon resposive-icon" size="26"
                icon="ChevronRightIcon" />
            <div class="wrapper-resposive-icon">
                <feather-icon v-if="isRoot && hasChildren" class="ChevronDownIcon d-none resposive-icon" size="26"
                    icon="ChevronDownIcon" />
            </div>
        </div>
        <div class="icon-mobilesite d-none">
            <feather-icon v-if="isRoot && hasChildren" class="ChevronRightIcon" size="22" icon="ChevronDownIcon" />
            <feather-icon v-if="isRoot && hasChildren" class="ChevronDownIcon d-none" size="22" icon="ChevronUpIcon" />
        </div>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButtonGroup,
    BButton,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BLink,
    BSpinner,
} from "bootstrap-vue";

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        store: {
            type: Object,
            required: true,
        },
    },
    components: {
        BRow,
        BCol,
        BCard,
        BCardText,
        BCardTitle,
        BCardSubTitle,
        BLink,
        BButtonGroup,
        BButton,
        BSpinner,
    },
    data() {
        return {
        };
    },
    mounted() {
        // this.store.toggleOpen(this.item);
    },
    computed: {
        isRoot() {
            return !!this.item.parent.isRoot;
        },
        hasChildren() {
            return this.item.children
                && this.countChildren > 0;
        },
        countChildren() {
            return this.item.children.length;
        },
        isVisible() {
            return this.searchVisible(this.item);
        }
    },
    methods: {
        searchVisible(item) {
            if (item.visible) {
                const parent = item.parent;
                if (parent && !parent.isRoot) {
                    return this.searchVisible(parent);
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        toggleFold(event) {
            if (event.target.tagName.toLowerCase() !== 'button') {
                this.store.toggleOpen(this.item)
            }
        },
        handleCreate() {
            this.$emit('onCreate', this.item);
        },
        handleUpdate() {
            this.$emit('onUpdate', this.item);
        },
        handleDelete() {
            this.$emit('onDelete', this.item);
        }
    },
}

</script>

<style scoped lang="scss">
.action-wrapper {
    .btn-group {
        @media (max-width: 600px) {
            display: flex;
            flex-direction: column;
        }

        .btn {
            font-size: 0.8rem;
        }
    }

    .resposive-icon {
        @media (max-width: 600px) {
            display: none;
        }
    }

    .wrapper-resposive-icon {
        @media (max-width: 600px) {
            display: none;
        }
    }
}

.he-tree {
    .icon-mobilesite {
        @media (max-width: 600px) {
            display: block !important;
            position: absolute;
            bottom: 5%;
            right: 50%;
            left: 50%;

        }
    }

    .tree-node {
        .node-infor-wrapper {
            & * {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .ChevronRightIcon,
        .ChevronDownIcon {
            margin-right: 0.5rem;
        }

        &.open>.tree-node-inner-back {
            .ChevronRightIcon {
                display: none !important;
            }

            .ChevronDownIcon {
                display: block !important;
            }
        }

        .CircleIcon {
            margin-top: 3px;
        }

        .group-icons {
            min-width: 55px;

            @media (max-width: 420px) {
                display: flex;
                align-items: center;
            }

            svg {
                color: #989898;
            }
        }

        .card {
            margin: 0;

            .card-title {
                margin-bottom: 0;
            }

            .card-subtitle {
                margin-top: 0.3rem;
            }

            .card-body {
                display: flex;
                padding: 0 16px;
                margin: 0;
                justify-content: space-between;

                .node-infor-wrapper, .action-wrapper {
                    padding: 5px 0;
                    overflow: hidden;
                    max-width: calc(100% - 80px);

                    @media (max-width: 425px) {
                        max-width: 50%;
                    }

                    h6 {
                        text-overflow: ellipsis;
                        overflow: hidden;
                        // Addition lines for 2 line or multiline ellipsis
                        display: -webkit-box !important;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        white-space: normal;


                    }

                    h4 {
                        &.card-title {
                            @media (max-width: 420px) {
                                align-items: center;
                                display: -webkit-box;
                                max-width: 200px;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                            }
                        }
                    }

                    @media (max-width: 420px) {
                        align-items: center;
                    }
                }
            }

            pre {
                background: unset;
            }

            &.root-node {
                margin: 0;
                padding: 8px 0;

                & .card-title {
                    margin: 0;
                }
            }

            &:hover {
                background-color: #EEE
            }

            button.btn {
                border: 0 !important;
                outline: unset;
            }
        }

        &.loading-children {
            .node-spinner {
                display: block !important;
                margin-right: 30px;

                &>span {
                    width: 1.5rem;
                    height: 1.5rem;
                    color: #cacaca !important;
                }
            }

            .group-icons {
                display: none;
            }
        }
    }
}
</style>
